'use client';

import React from 'react';
import { useLanguage } from '../../hooks/useAppLanguage';
import LegalDocument from './LegalDocument';
import { LEGAL_NOTICE, type LegalLang } from './siteLegal';

/** /fi/julkaisutiedot, /en/legal-notice, /de/impressum (published in fi, en and de only). */
const LegalNoticePage: React.FC = () => {
  const { language } = useLanguage();
  const lang = (language in LEGAL_NOTICE ? language : 'en') as LegalLang;
  return <LegalDocument doc={LEGAL_NOTICE[lang]} lang={lang} />;
};

export default LegalNoticePage;
